import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CommentForm from '@/components/Comments/CommentForm';
import CommentList from '@/components/Comments/CommentList';

/**
 * Comments component for displaying and managing post comments
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes to apply
 * @param {number} props.storyId - ID of the story/post to show comments for
 * @returns {JSX.Element} Comments component
 */
export default function Comments({ className, storyId }) {
  return (
    <div id={`comments-section-${storyId}`} className={classNames('w-full mom-border border-2 mom-intrinsic p-4 lg:p-6 mt-8 lg:mt-12 mb-4 lg:mb-8', className)}>
      <h2 className="font-light italic mb-2 lg:mb-4">Comments</h2>
      <CommentForm storyId={storyId} />
      <CommentList storyId={storyId} />
    </div>
  );
}

Comments.propTypes = {
  className: PropTypes.string,
  storyId: PropTypes.number.isRequired,
};
